// src/i18n/index.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationDE from "./locales/de/translation.json";

const germanDetector = {
    name: "germanDetector",
    lookup() {
        const browserLang = navigator.language || navigator.languages[0];
        return browserLang && browserLang.toLowerCase().includes("de") ? "de" : "en";
    },
};

i18n.use(LanguageDetector) // detects browser language
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: { translation: translationEN },
            de: { translation: translationDE },
        },
        fallbackLng: "en",
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
        },
        supportedLngs: ["en-GB", "en", "de-DE", "de"],

        interpolation: { escapeValue: false },

        load: "languageOnly",
        checkWhitelist: true,
    });

i18n.services.languageDetector.addDetector(germanDetector);

export default i18n;
